import React, { Fragment, Component } from 'react';
import './styles.scss';

const Dialog = ({ show, message, actions }) => {
    return (
        <Fragment>
            {show && <div className="modal-overlay">
                <div className='modal-dialog shadow'>
                    <h4 className="message">{message}</h4>
                    <div className="actions-container">
                        {actions && actions.map((action, i) => (
                            <button className="action" key={i} type="button" onClick={(e) => action.onClick(e)}>{action.label}</button>
                        ))}
                    </div>
                </div>
            </div>}
        </Fragment>
    );
}

export default Dialog;